import {AbstractPage} from "./AbstractPage";
import {JqueryApp} from "./JqueryApp";
import {format} from "./utils/misc";

// required lang keys: dateTimeFormatLocale: YYYY-MM-DD HH:mm:ss // use date.toLocaleString() instead
// justNow, minAgo, hourAgo

// optional: "timezone_diff":-60 // offset to UTC0 in minutes

export class Timestamps extends AbstractPage {
    protected timezoneDiffMin: number = 0;
    protected updateTimestampsTimer: number | null = null;
    protected unixTimestampAttr: string;

    constructor(app: JqueryApp, timezoneDiffMin: number = 0, unixTimestampAttr: string = "data-time") {
        super(app);
        this.timezoneDiffMin = timezoneDiffMin;
        this.unixTimestampAttr = unixTimestampAttr;
    }

    public updateTimestamps() {
        //const nowLocal = new Date();
        //const timestamp = this.getServerDate(); // use if server time is not GMT0
        const timestamp = Date.now() / 1000;
        const $ = this.app.$;
        const tr = this.app.getTr();

        $('.' + this.unixTimestampAttr).each((i, el) => {
            const $el = $(el);
            const added = $el.attr(this.unixTimestampAttr) as unknown as number;
            if (added == 0) // keep server value (might be "n/a" or "unknown"...)
                return;
            let diff = timestamp - added;
            let displayDate = "";
            if (diff > 0) {
                const showFullDate = $el.hasClass("date-full");
                if (diff <= 60*60 && !showFullDate) {
                    let minAgo = this.toInt(diff/60);
                    if (minAgo < 1)
                        displayDate = tr.get("justNow");
                    else
                        displayDate = format(tr.get("minAgo"), minAgo.toString());
                }
                else if (diff <= 24*60*60 && !showFullDate)
                    displayDate = format(tr.get("hourAgo"), this.toInt(diff/(60*60)).toString());
                else {
                    // else: update to regular datetime formats using user locale
                    displayDate = new Date(added*1000).toLocaleString();
                }
            }
            if (displayDate != "")
                $(el).html(displayDate);
        });
    }

    public updateTimestampsRepeating() {
        const $ = this.app.$;
        if (this.updateTimestampsTimer !== null) {
            clearTimeout(this.updateTimestampsTimer);
            this.updateTimestampsTimer = null;
        }
        if ($('.' + this.unixTimestampAttr).length === 0)
            return;
        this.updateTimestamps();
        this.updateTimestampsTimer = this.app.getWebHelpers().window.setTimeout(this.updateTimestampsRepeating.bind(this), 60*1000);
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected getServerDate(ms: boolean = false) {
        const date = new Date();
        let msDate = date.getTime() + (date.getTimezoneOffset()-this.timezoneDiffMin)*60000;
        return ms === true ? msDate : msDate/1000;
    }

    protected toInt(number: number) {
        if (number < 0)
            return Math.ceil(number);
        return Math.floor(number);
    }
}
